import { Flex, Select, ButtonGroup, Button, useColorModeValue } from '@chakra-ui/react';
import { User } from '../../types';

interface CalendarHeaderProps {
  view: 'month' | 'week' | 'day';
  onViewChange: (view: 'month' | 'week' | 'day') => void;
  selectedUser: string;
  onUserChange: (userId: string) => void;
  users: User[];
  currentUserId?: string;
}

/**
 * Calendar Header Component
 * Contains user filter and view type selector
 */
export function CalendarHeader({
  view,
  onViewChange,
  selectedUser,
  onUserChange,
  users,
  currentUserId,
}: CalendarHeaderProps) {
  const selectBg = useColorModeValue('white', 'gray.700');
  const buttonActiveBg = useColorModeValue('blue.600', 'blue.500');
  const buttonInactiveBg = useColorModeValue('white', 'gray.700');
  const buttonActiveColor = 'white';
  const buttonInactiveColor = useColorModeValue('gray.700', 'gray.300');
  const borderColor = useColorModeValue('gray.300', 'gray.600');
  const buttonHoverBg = useColorModeValue('gray.50', 'gray.600');

  return (
    <Flex justify="space-between" align="center" mb={4} gap={4} flexWrap="wrap">
      {/* User Filter */}
      <Select
        value={selectedUser}
        onChange={(e) => onUserChange(e.target.value)}
        maxW="200px"
        bg={selectBg}
        borderColor={borderColor}
      >
        <option value="all">All Users</option>
        {currentUserId && <option value={currentUserId}>My Items</option>}
        {users
          .filter((u) => u.id !== currentUserId)
          .map((u) => (
            <option key={u.id} value={u.id}>
              {u.name}
            </option>
          ))}
      </Select>

      {/* View Type Selector */}
      <ButtonGroup isAttached variant="outline" size="md">
        <Button
          onClick={() => onViewChange('day')}
          bg={view === 'day' ? buttonActiveBg : buttonInactiveBg}
          color={view === 'day' ? buttonActiveColor : buttonInactiveColor}
          _hover={{
            bg: view === 'day' ? buttonActiveBg : buttonHoverBg,
          }}
          borderColor={borderColor}
        >
          Day
        </Button>
        <Button
          onClick={() => onViewChange('week')}
          bg={view === 'week' ? buttonActiveBg : buttonInactiveBg}
          color={view === 'week' ? buttonActiveColor : buttonInactiveColor}
          _hover={{
            bg: view === 'week' ? buttonActiveBg : buttonHoverBg,
          }}
          borderColor={borderColor}
          borderLeft="none"
        >
          Week
        </Button>
        <Button
          onClick={() => onViewChange('month')}
          bg={view === 'month' ? buttonActiveBg : buttonInactiveBg}
          color={view === 'month' ? buttonActiveColor : buttonInactiveColor}
          _hover={{
            bg: view === 'month' ? buttonActiveBg : buttonHoverBg,
          }}
          borderColor={borderColor}
          borderLeft="none"
        >
          Month
        </Button>
      </ButtonGroup>
    </Flex>
  );
}

